import { HttpStatusCode } from "axios";
import ITestimonial from "../models/testimonial/ITestimonial";
import networkService from "./NetworkService";

class TestimonialService {

    /**
     * @description Gets all testimonials
     */
    async getTestimonials(): Promise<ITestimonial[]> {
        const result = await networkService.get<ITestimonial[]>(`/testimonials`);

        if (!result.isSuccessful) {
            throw result.data;
        }

        return result.status !== HttpStatusCode.NoContent
            ? result.data as ITestimonial[]
            : [];
    }

    /**
     * @description Gets the specified testimonial
     * @param {string} id The ID of the testimonial to be returned
     */
    async getTestimonial(id: string): Promise<ITestimonial> {
        const result = await networkService.get<ITestimonial>(`/testimonial/${id}`);

        if (result.isSuccessful) {
            return result.data as ITestimonial;
        }

        throw result.data;
    }

    /**
     * @description Creates a new testimonial
     * @param {ITestimonial} testimonial The testimonial data to be created
     */
    async createTestimonial(testimonial: ITestimonial): Promise<string> {
        const result = await networkService.put<ITestimonial, string>("/testimonial", testimonial);

        if (result.isSuccessful) {
            return result.data as string;
        }

        throw result.data;
    }

    /**
     * @description Updates the specified testimonial
     * @param {ITestimonial} testimonial The testimonial data to be updated
     */
    async updateTestimonial(testimonial: ITestimonial): Promise<ITestimonial> {
        const result = await networkService.patch<ITestimonial, ITestimonial>("/testimonial", testimonial);

        if (result.isSuccessful) {
            return result.data as ITestimonial;
        }

        throw result.data;
    }

    /**
     * @description Deletes the specified testimonial
     * @param {string} id The ID of the testimonial to be deleted
     * @param {string} industry The industry of the testimonial to be deleted
     */
    async deleteTestimonial(id: string, industry: string): Promise<boolean> {
        const result = await networkService.delete<void>(`/testimonial/${id}`, {
            "X-INDUSTRY": industry
        });
        
        return result.isSuccessful;
    }
}

const testimonialService = new TestimonialService();
export default testimonialService;